(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/insuranceFeatureConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var insuranceFeatureConfigService = require('./../urls').insuranceFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), insuranceFeatureConfigService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, insuranceFeatureConfigService) {
  'use strict';

  /**
   * Model for financial configuration information. Uses the InsurancelFeatureConfigService and corresponds to a InsuranceFeatureConfig
   *
   * @class InsuranceFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: insuranceFeatureConfigService,

    /**
     * @method isInsuranceEligibilityEnabled
     * @param configLevel {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isInsuranceEligibilityEnabled: function(configLevel) {
      var featureEnabled = this.isEnabled(configLevel),
          configLevelEnabled = this.get(configLevel + '.insuranceEligibilityEnabled');
      return featureEnabled && configLevelEnabled;
    },

    /**
     * @method isWalletInsurancesEnabled
     * @param configLevel {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isWalletInsurancesEnabled: function(configLevel) {
      var featureEnabled = this.isEnabled(configLevel),
          configLevelEnabled = this.get(configLevel + '.walletInsurancesEnabled');
      return featureEnabled && configLevelEnabled;
    }
  }))();
}));
